import { ProfileDeductionFragmentFragment } from "@/generated/graphql"
import { cn } from "@/lib/utils"
import ChevronRight from "@/novus/assets/images/chevron-right.svg"
import { Avatar } from "@/novus/components/avatar"
import { editDeductionPath } from "@/novus/novus-paths"
import { centsToDollars } from "@/util/currency"
import React, { useState } from "react"
import { Link } from "react-router-dom"
import invariant from "tiny-invariant"
import { useCurrentOrganization } from "@/novus/hooks/useCurrentOrganization"

const DeductionListItem = ({
  deduction,
}: { deduction: ProfileDeductionFragmentFragment }) => {
  const { organization } = useCurrentOrganization()
  const fiveTwoNineAccount = deduction.fiveTwoNineAccount
  const id = deduction.id
  invariant(id, "expected id")

  const programDetails = [
    fiveTwoNineAccount.program?.name,
    fiveTwoNineAccount.accountNumber,
  ]
    .filter(Boolean)
    .join(" | ")

  return (
    <Link
      to={editDeductionPath({ id })}
      className={cn(
        "shadow-custom-md px-4 py-3 flex flex-row items-center gap-4 border border-neutral-200 rounded-md",
        "hover:bg-neutral-50",
        "md:py-4 md:px-6",
      )}
      data-test="deduction-list-item"
    >
      <div className="flex items-center gap-4 flex-1">
        <Avatar
          viewer={{
            photoUrl: fiveTwoNineAccount.beneficiaryPhotoUrl,
            firstName: fiveTwoNineAccount.beneficiaryFirstName,
            lastName: fiveTwoNineAccount.beneficiaryLastName,
          }}
          size="md"
        />
        <div
          className={cn(
            "flex flex-1 flex-col gap-2",
            "md:justify-between md:flex-row md:gap-4",
          )}
        >
          <div>
            <div className="text-lg text-textPrimary line-clamp-2">
              {fiveTwoNineAccount.beneficiaryFirstName}{" "}
              {fiveTwoNineAccount.beneficiaryLastName}
            </div>
            {!!programDetails && (
              <div
                className="text-sm text-neutral-500 line-clamp-2"
                title={programDetails}
              >
                {programDetails}
              </div>
            )}
          </div>
          <div className={cn("flex items-center gap-8", "md:justify-end")}>
            <div className={cn("font-mono text-sm line-clamp-1", "md:text-lg")}>
              {centsToDollars(deduction.amountCents)}
            </div>
          </div>
        </div>
      </div>
      <div className="ml-4">
        <img src={ChevronRight} alt="View" />
      </div>
    </Link>
  )
}

export default DeductionListItem
